import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Modal } from 'react-frontier2';
import UserLog, { UserLogProps } from './UserLog';

interface UserLogModalProps extends UserLogProps{
	open: boolean,
	onClose: ()=>void,
}

var UserLogModal = (props: UserLogModalProps)=>{
	var { t } = useTranslation();
	useEffect(()=>{
		
	}, []);
	
	return <Modal open={props.open} onClose={props.onClose} size='tiny'>
		<Modal.Header>{t('common.users')}</Modal.Header>
		<Modal.Content>
			<UserLog {...props} fitted />
		</Modal.Content>
		<Modal.Actions>
			<Button text={t('common.close')} onClick={props.onClose} />
		</Modal.Actions>
	</Modal>
}

export default UserLogModal;